import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=c04149b2&"
import script from "./groups.ts?vue&type=script&lang=js&"
export * from "./groups.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports